import { httpRequest } from '../../app/common/util/api-common.util';

class LoginApi {
  static logar(payload) {
    return httpRequest('auth', 'POST', payload);
  }
  static obterUsuario(usuarioId) {
    return httpRequest(`recebimentomaterial/usuario/${usuarioId}`);
  }
  static verificarusuario(login) {
    return httpRequest('auth/verificarUsuario', 'POST', login);
  }
  static listarEmpresas(user) {
    return httpRequest(`auth/empresas-cas/${user}`);
  }
  static trocarSenha(payload) {
    return httpRequest('auth/alterarSenha', 'POST', payload);
  }

  static logout() {
    return httpRequest('auth/logout', 'patch');
  }
  static refreshToken() {
    return httpRequest('auth/renovarAutenticacao', 'patch');
  }

  static obterRestricoesAcesso(segusuid) {
    //new: api/v{version}/SegUsu/acesso/usuario/{segusuid}/RestricoesdeAcesso
    //old: api/v{version}/SegUsu/acesso/usuario/{segusuid}/material
    return httpRequest(`segusu/acesso/usuario/${segusuid}/RestricoesdeAcesso`);
    //return httpRequest(`segusu/acesso/usuario/${segusuid}/material`);
  }
}

export default LoginApi;



// WEBPACK FOOTER //
// ./src/pages/login/login.api.js